module.exports = __webpack_public_path__ + "static/media/world-icon.639b0ad4.svg";